(function (angular, undefined) {
    'use strict';

    angular
        .module('blocks.dragdrop', []);
})(angular);